import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const BrevoApiKey = (props) =>
  props.setingsLoader ? (
    <section className="FormViewSection">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px',
        }}
      >
        <Spinner animation="border" variant="dark" />
      </div>
    </section>
  ) : (
    <section className="FormViewSection">
      {props.brevoApiKey ? (
        !props.handelUpdateApiKey ? (
          // A key exists — show it read-only. The Update action needs edit access.
          <>
            {props.canEdit && (
              <div className="d-flex mb-5">
                <button
                  onClick={props.updateApiKey}
                  className="Button PrimaryButton ml-auto"
                >
                  <div className="Icon">
                    <i className="insight wpi-edit" />
                  </div>
                  <span>Update API KEY</span>
                </button>
              </div>
            )}
            <div className="FormViewDataWrapper">
              <div className="FormViewDataGroupLeft">
                <div className="FormViewGroup">
                  <p className="FormViewTitle">API KEY :</p>
                  <p className="FormViewData">{props.brevoApiKey}</p>
                </div>
              </div>
            </div>
          </>
        ) : (
          // Update mode (only reachable via the edit-gated Update button).
          <>
            <div className="FormViewGroup">
              <p className="FormViewTitle">API KEY :</p>
              <input
                type="text"
                className="form-control"
                placeholder="Your API Key..."
                onChange={(e) => props.setHandelBrevoApiKey(e.target.value)}
                value={props.handelBrevoApiKey}
              />
            </div>
            {props.brevoAPIKeyErr &&
              props.brevoAPIKeyErr.apiKey &&
              props.brevoAPIKeyErr.apiKey.length > 0 && (
                <div className="FormViewGroup">
                  <p className="FormViewTitle" />
                  <p style={{ color: 'red' }}>{props.brevoAPIKeyErr.apiKey}</p>
                </div>
              )}
            <div className="d-flex">
              <button
                onClick={props.cancelUpdateApiKey}
                className="Button SemiButtonDanger ml-auto"
              >
                <span>Cancel</span>
              </button>
              <button
                onClick={props.hadelStoreBrevoApiKey}
                className="Button PrimaryButton ml-3"
              >
                <span>Submit</span>
              </button>
            </div>
          </>
        )
      ) : props.canEdit ? (
        // No key yet + edit access — show the add form.
        <>
          <div className="FormViewGroup">
            <p className="FormViewTitle">API KEY :</p>
            <input
              type="text"
              className="form-control"
              placeholder="Your API Key..."
              onChange={(e) => props.setHandelBrevoApiKey(e.target.value)}
            />
          </div>
          {props.brevoAPIKeyErr &&
            props.brevoAPIKeyErr.apiKey &&
            props.brevoAPIKeyErr.apiKey.length > 0 && (
              <div className="FormViewGroup">
                <p className="FormViewTitle" />
                <p style={{ color: 'red' }}>{props.brevoAPIKeyErr.apiKey}</p>
              </div>
            )}
          <div className="d-flex">
            <button
              onClick={props.hadelStoreBrevoApiKey}
              className="Button PrimaryButton ml-auto"
            >
              <span>Submit</span>
            </button>
          </div>
        </>
      ) : (
        // No key + view-only access — read-only notice (no blank page).
        <div className="FormViewGroup">
          <p className="FormViewData">
            No Brevo API key has been configured for this company.
          </p>
        </div>
      )}
    </section>
  );

export default BrevoApiKey;
